import * as React from 'react'
import { createRoot } from 'react-dom/client'
import AppView from '@app'

const container = document.getElementById('dashboard-app')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(<AppView />)
